import React from "react";
import PropTypes from "prop-types";

//
import { ProgressBar } from "react-bootstrap";
let zxcvbn = require("zxcvbn");

function PasswordStrengthMeter({ password, action }) {
  const testedResult = zxcvbn(password);

  const createPasswordLabel = (result) => {
    switch (result) {
      case 0:
        action(result);
        return "Weak";
      case 1:
        action(result);
        return "Weak";
      case 2:
        action(result);
        return "Fair";
      case 3:
        action(result);
        return "Good";
      case 4:
        action(result);
        return "Strong";
      default:
        action(result);
        return "Weak";
    }
  };

  return (
    <div className="password-strength-meter">
      <ProgressBar now={testedResult.score} max={4} variant="success" />

      <label className="password-strength-meter-label">
        {createPasswordLabel(testedResult.score)}
      </label>
    </div>
  );
}

PasswordStrengthMeter.propTypes = {
  password: PropTypes.string.isRequired,
};

export default PasswordStrengthMeter;
